import { useTranslation } from "react-i18next"
import { AwardEntity } from "../../Objects/Awards/AwardEntity"
import { awardMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export const useGetAward = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetAward = async (onSuccess: any, database: string = API_ROUTES.AWARD.GET_ALL) => {
    enableLoad()

    try {
      const response = await GetRequest<AwardEntity[]>(database)

      if (response.success) {
        const temp = response.data?.map((ss) => new AwardEntity(ss)) ?? []

        awardMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetAward,
  }
}
